"use strict";

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contract_wrappers_1 = require("@polymathnetwork/contract-wrappers");

var Procedure_1 = require("./Procedure");

var types_1 = require("../types");

var PolymathError_1 = require("../PolymathError");

var TransferErc20_1 = require("./TransferErc20");

var entities_1 = require("../entities");

var utils_1 = require("../utils");
/**
 * Procedure that launches a Simple STO
 */


var LaunchSimpleSto =
/*#__PURE__*/
function (_Procedure_1$Procedur) {
  _inherits(LaunchSimpleSto, _Procedure_1$Procedur);

  function LaunchSimpleSto() {
    var _this;

    _classCallCheck(this, LaunchSimpleSto);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LaunchSimpleSto).apply(this, arguments));
    _this.type = types_1.ProcedureType.LaunchSimpleSto;
    return _this;
  }
  /**
   * - Transfer the necessary amount of POLY to the Security Token to cover the STO's setup fee
   * - Launch the Simple STO
   * - Allow pre-issuing (if applicable)
   * - Return the newly created STO
      * Notes:
   * - Pre-issuing defaults to false
   * - Pre-issuing can only be enabled on a version 3.1 (or greater) Simple STO. Attempting to do so in versions 3.0 or lower will cause the procedure to fail
   */


  _createClass(LaunchSimpleSto, [{
    key: "prepareTransactions",
    value: function prepareTransactions() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var _this2 = this;

        var args, context, symbol, startDate, endDate, tokensOnSale, rate, currency, raisedFundsWallet, unsoldTokensWallet, _args$allowPreIssuing, allowPreIssuing, contractWrappers, simpleStoFactory, securityToken, securityTokenAddress, moduleName, factoryAddress, moduleFactory, usdCost, _ref, _ref2, polyCost, isCostInPoly, cost, balance, difference, fundRaiseType, _ref3, _ref4, newStoAddress, newSto;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                args = this.args, context = this.context;
                symbol = args.symbol, startDate = args.startDate, endDate = args.endDate, tokensOnSale = args.tokensOnSale, rate = args.rate, currency = args.currency, raisedFundsWallet = args.raisedFundsWallet, unsoldTokensWallet = args.unsoldTokensWallet, _args$allowPreIssuing = args.allowPreIssuing, allowPreIssuing = _args$allowPreIssuing === void 0 ? false : _args$allowPreIssuing;
                contractWrappers = context.contractWrappers, simpleStoFactory = context.factories.simpleStoFactory;
                _context4.prev = 3;
                _context4.next = 6;
                return contractWrappers.tokenFactory.getSecurityTokenInstanceFromTicker(symbol);

              case 6:
                securityToken = _context4.sent;
                _context4.next = 12;
                break;

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4["catch"](3);
                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "There is no Security Token with symbol ".concat(symbol)
                });

              case 12:
                _context4.next = 14;
                return securityToken.address();

              case 14:
                securityTokenAddress = _context4.sent;
                moduleName = contract_wrappers_1.ModuleName.CappedSTO;
                _context4.next = 18;
                return contractWrappers.getModuleFactoryAddress({
                  tokenAddress: securityTokenAddress,
                  moduleName: moduleName
                });

              case 18:
                factoryAddress = _context4.sent;
                _context4.next = 21;
                return contractWrappers.moduleFactory.getModuleFactory(factoryAddress);

              case 21:
                moduleFactory = _context4.sent;
                usdCost = null;
                _context4.next = 25;
                return Promise.all([moduleFactory.setupCostInPoly(), moduleFactory.isCostInPoly(), moduleFactory.setupCost()]);

              case 25:
                _ref = _context4.sent;
                _ref2 = _slicedToArray(_ref, 3);
                polyCost = _ref2[0];
                isCostInPoly = _ref2[1];
                cost = _ref2[2];

                if (!isCostInPoly) {
                  usdCost = cost;
                }

                _context4.next = 33;
                return contractWrappers.polyToken.balanceOf({
                  owner: securityTokenAddress
                });

              case 33:
                balance = _context4.sent;
                difference = polyCost.minus(balance); // only transfer the required amount of POLY

                if (!difference.gt(new contract_wrappers_1.BigNumber(0))) {
                  _context4.next = 38;
                  break;
                }

                _context4.next = 38;
                return this.addProcedure(TransferErc20_1.TransferErc20)({
                  receiver: securityTokenAddress,
                  amount: difference
                });

              case 38:
                fundRaiseType = currency === types_1.Currency.ETH ? contract_wrappers_1.CappedSTOFundRaiseType.ETH : contract_wrappers_1.CappedSTOFundRaiseType.POLY;
                _context4.next = 41;
                return this.addTransaction(securityToken.addModuleWithLabel, {
                  tag: types_1.PolyTransactionTag.EnableCappedSto,
                  fees: {
                    usd: usdCost,
                    poly: polyCost
                  },
                  resolvers: [function (receipt) {
                    return __awaiter(_this2, void 0, void 0,
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee() {
                      var logs, _utils_1$findEvents, _utils_1$findEvents2, event, eventArgs, _module;

                      return _regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              logs = receipt.logs;
                              _utils_1$findEvents = utils_1.findEvents({
                                eventName: contract_wrappers_1.SecurityTokenEvents.ModuleAdded,
                                logs: logs
                              }), _utils_1$findEvents2 = _slicedToArray(_utils_1$findEvents, 1), event = _utils_1$findEvents2[0];

                              if (!event) {
                                _context.next = 6;
                                break;
                              }

                              eventArgs = event.args;
                              _module = eventArgs._module;
                              return _context.abrupt("return", _module);

                            case 6:
                              throw new PolymathError_1.PolymathError({
                                code: types_1.ErrorCode.UnexpectedEventLogs,
                                message: "The Capped STO was successfully launched but the corresponding event wasn't fired. Please report this issue to the Polymath team."
                              });

                            case 7:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee);
                    }));
                  }, function (receipt) {
                    return __awaiter(_this2, void 0, void 0,
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee2() {
                      var logs, _utils_1$findEvents3, _utils_1$findEvents4, event, eventArgs, _module;

                      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              logs = receipt.logs;
                              _utils_1$findEvents3 = utils_1.findEvents({
                                eventName: contract_wrappers_1.SecurityTokenEvents.ModuleAdded,
                                logs: logs
                              }), _utils_1$findEvents4 = _slicedToArray(_utils_1$findEvents3, 1), event = _utils_1$findEvents4[0];

                              if (!event) {
                                _context2.next = 6;
                                break;
                              }

                              eventArgs = event.args;
                              _module = eventArgs._module;
                              return _context2.abrupt("return", simpleStoFactory.fetch(entities_1.SimpleSto.generateId({
                                securityTokenId: entities_1.SecurityToken.generateId({
                                  symbol: symbol
                                }),
                                stoType: types_1.StoType.Simple,
                                address: _module
                              })));

                            case 6:
                              throw new PolymathError_1.PolymathError({
                                code: types_1.ErrorCode.UnexpectedEventLogs,
                                message: "The Capped STO was successfully launched but the corresponding event wasn't fired. Please report this issue to the Polymath team."
                              });

                            case 7:
                            case "end":
                              return _context2.stop();
                          }
                        }
                      }, _callee2);
                    }));
                  }]
                })({
                  moduleName: moduleName,
                  address: factoryAddress,
                  data: {
                    startTime: startDate,
                    endTime: endDate,
                    cap: tokensOnSale,
                    rate: rate,
                    fundRaiseType: fundRaiseType,
                    fundsReceiver: raisedFundsWallet,
                    treasuryWallet: unsoldTokensWallet
                  },
                  maxCost: polyCost,
                  archived: false
                });

              case 41:
                _ref3 = _context4.sent;
                _ref4 = _slicedToArray(_ref3, 2);
                newStoAddress = _ref4[0];
                newSto = _ref4[1];

                if (!allowPreIssuing) {
                  _context4.next = 48;
                  break;
                }

                _context4.next = 48;
                return this.addTransaction({
                  futureValue: newStoAddress,
                  futureMethod: function futureMethod(address) {
                    return __awaiter(_this2, void 0, void 0,
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee3() {
                      var stoModule;
                      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                        while (1) {
                          switch (_context3.prev = _context3.next) {
                            case 0:
                              _context3.next = 2;
                              return contractWrappers.moduleFactory.getModuleInstance({
                                name: contract_wrappers_1.ModuleName.CappedSTO,
                                address: address
                              });

                            case 2:
                              stoModule = _context3.sent;

                              if (!contract_wrappers_1.isCappedSTO_3_0_0(stoModule)) {
                                _context3.next = 5;
                                break;
                              }

                              throw new PolymathError_1.PolymathError({
                                code: types_1.ErrorCode.IncorrectVersion,
                                message: 'STO version is 3.0.0. Version 3.1.0 or greater is required for pre-issuing'
                              });

                            case 5:
                              return _context3.abrupt("return", stoModule.allowPreMinting);

                            case 6:
                            case "end":
                              return _context3.stop();
                          }
                        }
                      }, _callee3);
                    }));
                  }
                }, {
                  tag: types_1.PolyTransactionTag.AllowPreMinting,
                  resolvers: [function () {
                    return simpleStoFactory.update(entities_1.SimpleSto.generateId({
                      securityTokenId: entities_1.SecurityToken.generateId({
                        symbol: symbol
                      }),
                      stoType: types_1.StoType.Simple,
                      address: newStoAddress.result
                    }), {
                      preIssueAllowed: true
                    });
                  }]
                })({});

              case 48:
                return _context4.abrupt("return", newSto);

              case 49:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[3, 9]]);
      }));
    }
  }]);

  return LaunchSimpleSto;
}(Procedure_1.Procedure);

exports.LaunchSimpleSto = LaunchSimpleSto;